import React from "react"

function Bio(props) {
  return (
    <div>
      <div className="bio-about">
        <h1>Hey, I'm Lydia.<br></br>I absolutely love-hate the internet.</h1><br></br>
        I'm Writer/Support Engineer but more importantly a real-life human being. 🤪 
        <h2>
          I like words, music, photography, art, fashion — all of the best stuff! I'm just here so share a bit of my work with you, so feel free to stick around. I hope you enjoy my creations and musings!</h2>

      </div>



      <div className="contact-section">
      <h3>// Contact</h3>
      <li>Message me via <b><a href="mailto:lydiabaikATgmailDOTcom">Email</a></b></li>
      <li>Let's connect on <b><a href="https://www.linkedin.com/in/lydiabaik/">LinkedIn</a></b></li>
      </div>





    </div>

  )
}

export default Bio;